module.exports = __webpack_public_path__ + "img/30.c1183a93.jpg";